module.exports = __webpack_public_path__ + "static/media/andrea-giustina.49a2e6ea.jpeg";